import { ref } from '@vue/composition-api'

export function useImageLoading() {
  let timer = null
  let start = 0
  const progress = ref(0)
  const loading = ref(true)

  const imageProgress = function(instance, image) {
    const max = instance.images.length
    
    if (image.isLoaded) {
      start++

      if (timer) clearInterval(timer)

      timer = setInterval(() => {
        if (progress.value == Math.round(start * 100 / max)) {
          clearInterval(timer)
        } else {
          progress.value++
        }
      }, 50)

      if (start == max) setTimeout(() => loading.value = false, 300)
    }
  }

  return [ progress, loading, imageProgress ]
}